"use client";
import React, { useEffect, useRef } from 'react';
import { useLoading } from '@/Component/LoadingContext';
import { usePathname } from 'next/navigation';

const useFirstHomeVisit = () => {
  const { show, zoomIn, updateProgress } = useLoading();
  const path = usePathname();
  const location = path;
  const requestRef = useRef(0);
  const progressRef = useRef(0);
  useEffect(() => {
    // 현재 위치가 "/"가 아니면 리턴
    if (location !== '/') return;
    // 이전 페이지 정보 확인 (history나 referrer)
    progressRef.current=0;
    // 최초 홈 진입 판단
    show();
    zoomIn();

    const animate = () => {
      // 시간당 증가량 (조절 가능)
      progressRef.current += 1.5;
      updateProgress(Math.min(progressRef.current, 100));

      if (progressRef.current < 100) {
        requestRef.current = requestAnimationFrame(animate);
      }
    };
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [location]);
};

export default useFirstHomeVisit;